import { PrescricaoEnderecoRelatorioFiltroDTO } from "@/interfaces/address-prescriptions-report";
import { ENDPOINTS } from "@/settings/api-settings";
import { AxiosResponse } from "axios";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";

export function listDataAddressPrescriptionsReport(filters: PrescricaoEnderecoRelatorioFiltroDTO): Observable<any> {
  return from(
    apiClient.get(ENDPOINTS.ADDRESS_PRESCRIPTIONS_REPORT, filters),
  ).pipe(map((r: any) => r.data || {}));
}

export function buildAddressPrescriptionsXlsReport(filters: PrescricaoEnderecoRelatorioFiltroDTO): Observable<AxiosResponse> {
  return from(
    apiClient.download(ENDPOINTS.ADDRESS_PRESCRIPTIONS_REPORT_XLS, filters),
  );
}